import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { WorkspaceLayoutPreset } from 'generated/graphql';
import { Colors } from 'styles/index';
import { WorkspaceLayoutMenuItem } from './WorkspaceLayoutMenuItem';
import Box from '@mui/material/Box';
import { transparentize } from 'color2k';

type WorkspaceLayoutMenuSectionProps = {
  title: string;
  workspaceLayoutPresets: Array<Partial<WorkspaceLayoutPreset>>;
  onEdit?: (preset: Partial<WorkspaceLayoutPreset>) => void;
  onClone?: (preset: Partial<WorkspaceLayoutPreset>) => void;
  onDelete?: (preset: Partial<WorkspaceLayoutPreset>) => Promise<void>;
};
export const WorkspaceLayoutMenuSection = ({
  title,
  workspaceLayoutPresets,
  onEdit,
  onClone,
  onDelete,
}: WorkspaceLayoutMenuSectionProps) => {
  if (!workspaceLayoutPresets || workspaceLayoutPresets.length === 0) {
    return null;
  }

  return (
    <Stack vertical space="small">
      <Text
        variant="caption"
        color="secondary"
        css={`
          text-transform: uppercase;
          letter-spacing: 0.08em;
          font-weight: 600;
          opacity: 0.75;
          font-size: 10px;
        `}
      >
        {title}
      </Text>
      <Box
        sx={{
          maxHeight: 350,
          overflowY: 'auto',
          overflowX: 'auto',
          pr: 3,
          scrollbarGutter: 'stable',
        }}
      >
        <Box
          sx={{
            border: `1px solid ${transparentize(Colors.gray5, 0.5)}`,
            borderRadius: 1.5,
          }}
        >
          {workspaceLayoutPresets.map((preset, index) => (
            <WorkspaceLayoutMenuItem
              key={preset.id ?? index}
              workspaceLayoutPreset={preset}
              onEdit={onEdit}
              onClone={onClone}
              onDelete={onDelete}
            />
          ))}
        </Box>
      </Box>
    </Stack>
  );
};
